import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../../../styles/constants.style";

export const AddExistingProgramSearchResultWrapper = styled.div`
  margin: 19px 0px 39px;
  ${responsive.MOBILE`
    margin: 16px 0 0;
  `}
  .form-header {
    display: flex;
    align-items: center;
    background-color: ${COLORS.primary_light_blue2};
    padding: 10px 16px;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }

  .selected-count {
    color: ${COLORS.cirrus_white};
    background-color: ${COLORS.cirrus_black7};
    padding: 2px 9px 4px 9px;
    border-radius: 8px;
    margin-left: 8px;
    height: 28px;
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .search-result-header-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    align-items: center;
    width: 100%;

    ${responsive.MOBILE`
        background-color: ${COLORS.cirrus_white};
        align-self: flex-start;
        flex-direction: column;
        .search-header-right {
          align-self: flex-start;
          padding-top: 16px;
          width: 100%;
        }
        .search-header-right > * {
          flex: 1;           
        }
        .search-result-header {
          align-self: flex-start;
        }
      `}
  }

  .search-header-right {
    display: flex;
    justify-content: space-between;
  }
`;
